// Module
var code = "<div class=\"sb-add-new-card\"> <div class=\"sb-add-new-card-content\" ng-click=\"teamCreate.onAddTeam()\" data-cy=\"create-team\"> <i class=\"mdi mdi-plus\"></i> <span translate>SECTION_TEAMS_ADD_NEW_TITLE</span> <br/> </div> </div> ";
// Exports
var _module_exports =code;;
var path = '/var/lib/jenkins/workspace/Sablono_sb-bimtime_master/app/scripts/states/teams/components/team_create/team_create.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;